import "leaflet/dist/leaflet.css";
import { MapContainer, TileLayer, CircleMarker, Popup } from "react-leaflet";

const CATS = ["Médecins", "Chirurgiens-dentistes", "Paramédicaux", "Pharmacies", "Laboratoires & imagerie", "Établissements de soins"];
const COLORS = ["#C2410C", "#1D4ED8", "#7C3AED", "#0F766E", "#A16207", "#9F1239"];
const color = (c) => COLORS[Math.max(0, CATS.indexOf(c))];

export const DirectoryMap = ({ data, onOpen }) => (
  <div className="space-y-2">
    <div className="h-[560px] rounded-lg overflow-hidden border border-stone-200 relative z-0" data-testid="directory-map">
      <MapContainer center={[34.5, 3.0]} zoom={6} minZoom={4} preferCanvas style={{ height: "100%", width: "100%" }}>
        <TileLayer attribution="&copy; OpenStreetMap" url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        {(data?.points || []).map((p) => (
          <CircleMarker key={p.id} center={[p.lat, p.lng]} radius={5} pathOptions={{ color: color(p.category), fillColor: color(p.category), fillOpacity: 0.7, weight: 1 }}>
            <Popup>
              <div className="text-sm space-y-1">
                <p className="font-bold">{p.name}</p>
                <p>{p.subcategory}</p>
                {p.phone && <p>{p.phone}</p>}
                <button type="button" className="text-[#C2410C] underline" onClick={() => onOpen(p)} data-testid={`map-open-${p.id}`}>Ouvrir la fiche</button>
              </div>
            </Popup>
          </CircleMarker>
        ))}
      </MapContainer>
    </div>
    <div className="flex flex-wrap gap-4 text-xs text-stone-600">
      {CATS.map((c) => <span key={c} className="flex items-center gap-1.5"><span className="h-2.5 w-2.5 rounded-full" style={{ background: color(c) }} />{c}</span>)}
      {data?.truncated && <span className="ml-auto text-amber-700" data-testid="directory-map-truncated">{data.points.length} sur {data.total} affichés — affinez les filtres</span>}
    </div>
  </div>
);
